import { render, staticRenderFns } from "./ViberDetailIncoming.vue?vue&type=template&id=e83be944&"
import script from "./ViberDetailIncoming.vue?vue&type=script&lang=ts&"
export * from "./ViberDetailIncoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports